import { Link, useSearchParams } from "react-router-dom";

export default function CheckoutSuccessPage() {
  const [params] = useSearchParams();
  const orderNumber = params.get("order_number");

  return (
    <main className="min-h-screen bg-[#FCF9F0] px-6 py-20" data-testid="checkout-success-page">
      <section className="mx-auto max-w-2xl rounded-2xl border border-[#E4DAC4] bg-[#FBFAF4] p-8 text-center">
        <h1 className="font-head text-3xl text-[#203A6B]">Your payment was submitted</h1>
        <p className="mt-4 font-body text-base text-[#333333]">
          Stripe has returned you to Paw-Some Reports. We are confirming the payment now.
        </p>
        {orderNumber && (
          <p className="mt-4 font-body text-base text-[#333333]" data-testid="success-order-number">
            Paw-Some order number: <strong>{orderNumber}</strong>
          </p>
        )}
        <p className="mt-4 font-body text-sm text-[#4a4841]">
          Your confirmation and secure photo-upload instructions will be prepared after payment confirmation.
        </p>
        <Link className="mt-7 inline-block font-head text-[#3E731C] underline" to="/">
          Return to Homeroom
        </Link>
      </section>
    </main>
  );
}
